module.exports = __webpack_public_path__ + "img/paste.c9ceeece.svg";